module.exports = __webpack_public_path__ + "img/sub.1d37d7eb.png";